import usePermission from "hooks/usePermission";
import Error403 from "pages/Error403"

function PermissionRoute({ permission, children }) {
    const { hasPermission, isPermissionReady } = usePermission();

    if (!isPermissionReady) {
        return null;
    }

    if (!hasPermission(permission)) {
        return <Error403 />;
    }

    return children;
}
export default PermissionRoute;